import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const items = t('faq.items');
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };
  return <section id="faq" className="py-20 lg:py-28 bg-white" data-id="element-148">
      <div className="container mx-auto px-6" data-id="element-149">
        <div className="grid lg:grid-cols-12 gap-16 max-w-6xl mx-auto" data-id="element-150">
          {/* Left: heading */}
          <div className="lg:col-span-4" data-id="element-151">
            <div className="lg:sticky lg:top-32" data-id="element-152">
              <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-153">
                {t('faq.eyebrow')}
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-154">
                {t('faq.heading')}
              </h2>
              <div className="w-12 h-px bg-brand-gold mb-6" data-id="element-155"></div>
              <p className="text-brand-dark/60 font-light leading-relaxed" data-id="element-156">
                {t('faq.subheading')}
              </p>
            </div>
          </div>

          {/* Right: accordion */}
          <div className="lg:col-span-8" data-id="element-157">
            <div className="divide-y divide-brand-stone/50" data-id="element-158">
              {items.map((item: any, idx: number) => {
              const isOpen = openIndex === idx;
              return <motion.div key={idx} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                margin: '-50px'
              }} transition={{
                duration: 0.6,
                delay: idx * 0.05,
                ease: easeOutCubic
              }} data-id="element-159">
                    <button onClick={() => toggle(idx)} className="w-full flex items-start justify-between gap-8 py-7 text-left group" aria-expanded={isOpen} data-id="element-160">
                      <span className="font-serif text-lg lg:text-xl text-brand-dark font-light group-hover:text-brand-ink transition-colors flex-1" data-id="element-161">
                        {item.q}
                      </span>
                      <span className="shrink-0 mt-1 text-brand-dark/40 group-hover:text-brand-gold transition-colors" data-id="element-162">
                        {isOpen ? <MinusIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-163" /> : <PlusIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-164" />}
                      </span>
                    </button>
                    <AnimatePresence data-id="element-165">
                      {isOpen && <motion.div initial={{
                    opacity: 0,
                    height: 0
                  }} animate={{
                    opacity: 1,
                    height: 'auto'
                  }} exit={{
                    opacity: 0,
                    height: 0
                  }} transition={{
                    duration: 0.4,
                    ease: easeOutCubic
                  }} className="overflow-hidden" data-id="element-166">
                          <p className="pb-7 pr-12 text-brand-dark/65 font-light leading-relaxed" data-id="element-167">
                            {item.a}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}